import { RouteParams } from "vue-router"

export const enum AlertType {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  WARNING = "WARNING"
}

export interface AlertRespDetail {
  responseStatus?: number | string
  requestUrl?: string
  traceId?: string
  message?: string
}

export interface ShowAlertConfig {
  type?: AlertType
  timeout?: number
  theme?: string
  content?: AlertContentItem[]
  contentTitle?: AlertContentItem[]
  uniqueType?: string
  alertRespDetail?: AlertRespDetail
  hideDetails?: boolean
  routerLink?: AlertRouterLink
  /** Waits for a free place instead of pushing out older toasts, so every toast of a burst is shown. */
  queued?: boolean
}

export interface AlertContentItem {
  text: string
  type: "bold" | "regular"
}

export interface CutAlertContent {
  field: string
  numberOfSymbols?: number
}

export interface AlertReport {
  responseStatus: string | number
  requestUrl: string
  pageUrl: string
  message?: string
  traceId?: string
}

export interface AlertRouterLink {
  title: string
  name: string
  params: RouteParams
  query?: RouteParams
}

export class Alert {
  id: string
  content: AlertContentItem[]
  contentTitle: AlertContentItem[]
  theme?: "global" | "toast"
  type: AlertType
  timeout?: number
  timeoutStarted: boolean
  alertRespDetail?: AlertRespDetail

  uniqueType?: string
  timeoutCallbackId: ReturnType<typeof setTimeout>
  hideDetails = true
  name?: string
  title?: string
  message?: string
  routerLink?: AlertRouterLink
  queued: boolean

  constructor(props) {
    this.id = props.id ?? ""
    this.content = props.content ?? []
    this.contentTitle = props.contentTitle ?? []
    this.theme = props.theme ?? null
    this.type = props.type ?? ""
    this.timeout = props.timeout ?? null
    this.timeoutStarted = props.timeoutStarted ?? false
    this.uniqueType = props.uniqueType ?? null
    this.timeoutCallbackId = props.timeoutCallbackId
    this.alertRespDetail = props.alertRespDetail ?? null
    this.hideDetails = props.hideDetails ?? true
    this.name = props.name ?? ""
    this.title = props.title ?? ""
    this.message = props.message ?? ""
    this.routerLink = props.routerLink
    this.queued = props.queued ?? false
  }

  setupTimeout() {
    const timeoutDuration = this.timeout ?? 5000
    this.startTimer(timeoutDuration)
  }

  cancelTimeout() {
    clearTimeout(this.timeoutCallbackId)
  }

  restartTimeout() {
    this.startTimer(3000)
  }

  private startTimer(duration: number) {
    this.cancelTimeout()
    this.timeoutCallbackId = setTimeout(() => {
      this.hideToast()
    }, duration)
  }

  hideToast() {
    this.timeout = -1
  }
}
